// 首页接口
import http from '../utils/request'

export default {
  // 数据统计
  dataStatistics(data) {
    return http.get('/pc/clientApi/home/dataStatistics', { params: data })
  },
  // 故障趋势
  faultTrend() {
    return http.get('/pc/clientApi/home/faultTrend')
  },
  // 公告列表
  noticeList(data) {
    return http.get('/pc/clientApi/home/noticeList', { params: data })
  },
  // 公告未读数
  noticeUnReadCount() {
    return http.get('/pc/clientApi/home/noticeUnReadCount')
  },
  // 公告详情
  noticeDetail(data) {
    return http.post('/pc/clientApi/home/noticeDetail/' + data)
  },
  // 消息未读数
  messageUnReadCount() {
    return http.get('/pc/clientApi/home/messageUnReadCount')
  },
  // 获取消息列表
  messageList(data) {
    return http.get('/pc/clientApi/home/messageList', { params: data })
  },
  // 设置消息已读
  messageRead(data) {
    return http.post('/pc/clientApi/home/messageRead/' + data)
  },
  // 待分配工单 员工
  needDistribute(data) {
    return http.get('/pc/clientApi/home/needDistribute', { params: data })
  },
  // 待分配工单 管理员
  needDistributeAdmin(data) {
    return http.get('/pc/clientApi/home/needDistributeAdmin', { params: data })
  },
  // 待验收工单 员工
  dataEvaluate(data) {
    return http.get('/pc/clientApi/home/dataEvaluate', { params: data })
  },
  // 待验收工单 管理员
  dataEvaluateAdmin(data) {
    return http.get('/pc/clientApi/home/dataEvaluateAdmin', { params: data })
  },
  // 待接单 员工
  needReceive(data) {
    return http.get('/pc/clientApi/home/needReceive', { params: data })
  },
  // 待接单 管理员
  needReceiveAdmin(data) {
    return http.get('/pc/clientApi/home/needReceiveAdmin', { params: data })
  },
	// 提交延期申请
	applyAdd(data) {
	  return http.post('/pc/clientApi/expiration/apply/add', data)
	},
	
}
